module.exports = __webpack_public_path__ + "img/terminal.e3d49792.png";